import { useEffect, useState } from 'react';

export const cardholdersValidatior = ({ productList, generateId, parentId }: any) => {
  const response = false;
  const cloneProductList = [...productList];
  const parentCardholdersNumber = cloneProductList?.filter((item) => item?.parentId === parentId)?.length;
  return { parentCardholdersNumber };
};

export const useReOrderHandler = (servicesDta: any = []) => {
  console.log('servzzzizxcesDtaservicesDta', servicesDta);
  const CorportiveObj = servicesDta[2];
  const TravelObj = servicesDta[1];
  const paymentObj = servicesDta[0];

  return [CorportiveObj, paymentObj, TravelObj];
};
